import { render, staticRenderFns } from "./classical-information-upload.vue?vue&type=template&id=1385ef32"
import script from "./classical-information-upload.vue?vue&type=script&lang=js"
export * from "./classical-information-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports